
<!-- <button class="icon-button" (click)="openDateShifter($event)"><span class="material-icons filter-icon" [style.color]="'black'">swap_horiz</span> Shift Dates</button> -->
<div class="calendar-controls-row">
  <div class="calendar-controls-left">
    <span *ngIf="isLoading" style="margin-left: 30px;">
      <span class="material-symbols-outlined" style="vertical-align: middle; margin-right: 10px;">hourglass</span>
      <span style="vertical-align: middle;">Loading...</span>
    </span>
    <span *ngIf="!isLoading && showNewWindowIcon" class="material-icons general-action-icon new-window-icon" 
          (click)="openInNewTab(projectData?.ProjectNumber)" title="Open Project in New Tab">open_in_new</span>
    <span *ngIf="!isLoading && !showNewWindowIcon" class="material-icons general-action-icon settings-icon"></span>
  </div>

  <div class="calendar-controls-center">
    <date-range-selector
      *ngIf="!isLoading"
      [minDate]="dateSelectorMinDate"
      [maxDate]="dateSelectorMaxDate"
      [selectedDate]="dateSelectorSelectedDate"
      [showWeeks]="filterSettings.showWeeks"
      (selectedDateChange)="dateSelectorChanged($event)">
    </date-range-selector>
  </div>

  <div class="calendar-controls-right" *ngIf="!isLoading">
    <!-- Zoom controls -->
    <span class="zoom-controls">
      <button class="zoom-button" (click)="zoomOut()" aria-label="Zoom out" title="Zoom Out">
        <span class="material-icons">zoom_out</span>
      </button>
      <span class="zoom-slider-group">
        <input type="range" min="50" max="200" step="10" [value]="zoomLevel * 100" (input)="onZoomRange($event)" class="zoom-slider" />
      </span>
      <button class="zoom-button" (click)="zoomIn()" aria-label="Zoom in" title="Zoom In">
        <span class="material-icons">zoom_in</span>
      </button>
      <span class="zoom-label">{{ (zoomLevel * 100) | number:'1.0-0' }}%</span>
    </span>
    <span class="slider-block">
      <span class="material-icons general-action-icon settings-icon" (click)="openFilterMenu($event)" title="Settings">settings</span>
    </span>
  </div>
</div>

<!-- Viewport wrapper enables zoom + scrolling -->
<div class="calendar-viewport-wrapper" #calendarViewportWrapper [style.height.px]="viewportHeightPx">
  <div *ngIf="updating && !isLoading" class="calendar-updating-overlay" role="status" aria-live="polite" aria-label="Updating calendar">
    <div class="calendar-updating-message">
      <span class="material-icons history-icon">update</span>
      <span>Updating...</span>
    </div>
  </div>
  <div class="calendar-viewport"
  #calendarViewport
       [style.transform]="'scale(' + zoomLevel + ')'"
       [style.transformOrigin]="zoomOrigin"
       [style.width.%]="100 / zoomLevel">
    <table *ngIf="!isLoading && !isWeekView()" class="calendar-grid">
  <tr>
    <td *ngIf="filterSettings.activity" class="activity-project-number" [class.activity-project-number-multi]="showProjectActivityColumn">Project Number</td>
    <td *ngIf="filterSettings.activity && !showProjectActivityColumn" class="activity-item-description">Description</td>
    <td *ngIf="filterSettings.activity && showProjectActivityColumn" class="activity-item-activity activity-item-activity-multi activity-item-activity-header">Activity</td>
    <td *ngIf="!filterSettings.activity" class="calendar-heading-activity">Activity</td>
    <td *ngFor="let month of filterSettings.months" class="calendar-heading-month" 
      [attr.colspan]="getMonthColumnSpan(month)">{{ month }}</td>
  </tr>
  <tr>
    <td *ngIf="filterSettings.activity" class="activity-project-number" [class.activity-project-number-multi]="showProjectActivityColumn"></td>
    <td *ngIf="filterSettings.activity && !showProjectActivityColumn" class="activity-item-description"></td>
    <td *ngIf="filterSettings.activity && showProjectActivityColumn" class="activity-item-activity activity-item-activity-multi activity-item-activity-header"></td>
    <td *ngIf="!filterSettings.activity" class="calendar-heading-activity"></td>
    <td *ngFor="let dayColumn of dayColumns; trackBy: trackByDate" class="calendar-heading-day"
        [class.first-of-month]="dayColumn.isFirstOfMonth"
        [class.weekend-day]="dayColumn.isWeekend"
      [class.today]="dayColumn.isToday">{{ dayColumn.dayNumber }}</td>
  </tr>
    <tr *ngFor="let activity of visibleActivities; trackBy: trackByActivityId; let rowIndex = index"
      [class.project-separator-row]="(filterSettings.activity && showProjectActivityColumn && rowIndex === 0) || shouldShowProjectSeparator(rowIndex)">
    <td *ngIf="filterSettings.activity && shouldShowProjectInfo(activity)"
        class="activity-project-number"
        [class.activity-project-number-multi]="showProjectActivityColumn"
        [attr.rowspan]="activity.__projectActivityCount">
      <div class="activity-project-number-cell">
        <span class="week-project-number-line">
          <span class="project-number" [class.project-number-multi]="showProjectActivityColumn" (click)="openProjectNumber(activity.ProjectNumber)">{{ activity.ProjectNumber }}</span>
            <span *ngIf="showProjectActivityColumn" class="material-icons week-project-info-icon"
                  (mouseenter)="showWeeklyProjectDetails(activity.ProjectNumber, $event)"
              (mouseleave)="hideWeeklyProjectDetails()">info_outline</span>
          <span *ngIf="!showProjectActivityColumn" class="project-status-block" [style.background-color]="activity.IsOnHold ? getStatusColor(5) : activity.ProjectHasShipped ? shippedColor : getStatusColor(activity.ProjectStatusId)"></span>
        </span>
        <span *ngIf="showProjectActivityColumn" class="week-project-end-user">{{ activity.EndUser }}</span>
        <span *ngIf="showProjectActivityColumn" class="week-project-status-line">
          <span class="project-status-block" [style.background-color]="activity.IsOnHold ? getStatusColor(5) : activity.ProjectHasShipped ? shippedColor : getStatusColor(activity.ProjectStatusId)"></span>
          <span class="week-project-status-label">{{ activity.IsOnHold ? 'On Hold' : activity.ProjectHasShipped ? 'Shipped' : getStatusName(activity.ProjectStatusId) }}</span>
        </span>
      </div>
    </td>
    <td *ngIf="filterSettings.activity && !showProjectActivityColumn" class="activity-item-description">
        {{ getProjectDescriptionDisplay(activity) }}
    </td>
    <td *ngIf="filterSettings.activity && showProjectActivityColumn" class="activity-item-activity activity-item-activity-multi">
      {{ getProjectActivityDisplay(activity) }}
    </td>
    <td *ngIf="!filterSettings.activity" [class.activity-name-milestone]="activity.IsMilestone" 
      [class.activity-name-normal]="!activity.IsMilestone">
        <span class="material-symbols-outlined responsible-party-icon" 
              [style.color]="getResponsiblePartyColor(activity.ResponsiblePartyId, false)"
              [title]="getResponsiblePartyName(activity.ResponsiblePartyId)">{{ getActivityIcon(activity) }} </span> 
        {{ activity.Name }}
        <span class="material-symbols-outlined history-icon" 
              (click)="openActivityHistory(activity, $event)" 
              title="View History">history</span>
          <span *ngIf="activity.NoteCount > 0 || activity.HasExpectedDatesOverride"
            class="note-count-bubble"
            [class.note-count-bubble-override]="activity.HasExpectedDatesOverride">{{ activity.NoteCount }}</span>
          <span *ngIf="activity.NoteCount > 0 || activity.HasExpectedDatesOverride"
            class="material-symbols-outlined notes-icon"
            [class.notes-icon-override]="activity.HasExpectedDatesOverride"
            (click)="openNotes(activity)" 
            title="View Notes">chat</span>
    </td>
    <td *ngFor="let dayCell of activity.dayCells; trackBy: trackByDayCellDate" class="activity-day"
        [class.activity-day-hover]="!activity.IsMilestone"
        [class.first-of-month]="dayCell.isFirstOfMonth"
        [class.weekend-day]="dayCell.isWeekend"
        [class.today]="dayCell.isToday"
        [class.holiday]="dayCell.isHoliday"
        [class.milestone]="activity.IsMilestone"
        [class.locked]="activity.IsLocked"
        (mouseover)="onCellMouseOver($event, activity, dayCell.date)"
        (mousedown)="onCellMouseDown($event, activity, dayCell.date)"
        (mouseup)="onCellMouseUp($event, activity, dayCell.date)"
        (wheel)="onCellMouseWheel($event, activity, dayCell.date)"
        (contextmenu)="openContextMenu($event, activity, dayCell.date)">
      <div
        class="activity-cell no-select"
        [style]="selectionRowId === activity.Id && selectionStartDate !== null && selectionEndDate !== null && dayCell.date >= selectionStartDate && dayCell.date <= selectionEndDate ? '' : dayCell.style"
        [class.selected-day]="selectionRowId === activity.Id && selectionStartDate !== null && selectionEndDate !== null && dayCell.date >= selectionStartDate && dayCell.date <= selectionEndDate"
      >&nbsp;
      </div>
    </td>
  </tr>
  </table>
  <table *ngIf="!isLoading && isWeekView()" class="calendar-grid week-view-calendar-grid">
  <tr>
    <td *ngIf="filterSettings.activity" class="activity-project-number">Project Number</td>
    <td *ngIf="filterSettings.activity && showProjectActivityColumn" class="activity-item-activity activity-item-activity-header">Activity</td>
    <td *ngIf="!filterSettings.activity" class="calendar-heading-activity">Activity</td>
    <td *ngFor="let yearGroup of yearGroups; trackBy: trackByYearGroup" class="calendar-heading-month"
      [attr.colspan]="yearGroup.span">{{ yearGroup.year }}</td>
  </tr>
  <tr>
    <td *ngIf="filterSettings.activity" class="activity-project-number"></td>
    <td *ngIf="filterSettings.activity && showProjectActivityColumn" class="activity-item-activity activity-item-activity-header"></td>
    <td *ngIf="!filterSettings.activity" class="calendar-heading-activity"></td>
    <td *ngFor="let week of weekGroups; trackBy: trackByWeekGroup" class="calendar-heading-day"
      [class.first-of-month]="isFirstWeekOfYear(week)">{{ week.weekNumber }}</td>
  </tr>
    <tr *ngFor="let activity of visibleActivities; trackBy: trackByActivityId; let rowIndex = index"
      [class.project-separator-row]="(filterSettings.activity && showProjectActivityColumn && rowIndex === 0) || shouldShowProjectSeparator(rowIndex)">
    <td *ngIf="filterSettings.activity && shouldShowProjectInfo(activity)"
        class="activity-project-number"
        [attr.rowspan]="activity.__projectActivityCount">
      <div class="activity-project-number-cell">
        <span class="week-project-number-line">
          <span class="project-number" (click)="openProjectNumber(activity.ProjectNumber)">{{ activity.ProjectNumber }}</span>
            <span *ngIf="showProjectActivityColumn"
              class="material-icons week-project-info-icon"
              (mouseenter)="showWeeklyProjectDetails(activity.ProjectNumber, $event)"
              (mouseleave)="hideWeeklyProjectDetails()">info_outline</span>
          <span *ngIf="!showProjectActivityColumn" class="project-status-block" [style.background-color]="activity.IsOnHold ? getStatusColor(5) : activity.ProjectHasShipped ? shippedColor : getStatusColor(activity.ProjectStatusId)"></span>
        </span>
        <span class="week-project-end-user">{{ activity.EndUser }}</span>
        <span *ngIf="showProjectActivityColumn" class="week-project-status-line">
          <span class="project-status-block" [style.background-color]="activity.IsOnHold ? getStatusColor(5) : activity.ProjectHasShipped ? shippedColor : getStatusColor(activity.ProjectStatusId)"></span>
          <span class="week-project-status-label">{{ activity.IsOnHold ? 'On Hold' : activity.ProjectHasShipped ? 'Shipped' : getStatusName(activity.ProjectStatusId) }}</span>
        </span>
      </div>
    </td>
    <td *ngIf="filterSettings.activity && showProjectActivityColumn" class="activity-item-activity">
      {{ getProjectActivityDisplay(activity) }}
    </td>
    <td *ngIf="!filterSettings.activity" [class.activity-name-milestone]="activity.IsMilestone" [class.activity-name-normal]="!activity.IsMilestone">
      <span class="material-symbols-outlined responsible-party-icon"
            [style.color]="getResponsiblePartyColor(activity.ResponsiblePartyId, false)"
            [title]="getResponsiblePartyName(activity.ResponsiblePartyId)">{{ getActivityIcon(activity) }} </span>
      {{ activity.Name }}
      <span class="material-symbols-outlined history-icon"
            (click)="openActivityHistory(activity, $event)"
            title="View History">history</span>
      <span *ngIf="activity.NoteCount > 0 || activity.HasExpectedDatesOverride"
        class="note-count-bubble"
        [class.note-count-bubble-override]="activity.HasExpectedDatesOverride">{{ activity.NoteCount }}</span>
      <span *ngIf="activity.NoteCount > 0 || activity.HasExpectedDatesOverride"
            class="material-symbols-outlined notes-icon"
            [class.notes-icon-override]="activity.HasExpectedDatesOverride"
            (click)="openNotes(activity)"
            title="View Notes">chat</span>
    </td>
    <td *ngFor="let week of weekGroups; trackBy: trackByWeekGroup" class="activity-day"
        [class.first-of-month]="isFirstWeekOfYear(week)"
        [class.today]="isWeekToday(week)"
        [class.holiday]="false"
        [class.milestone]="activity.IsMilestone"
        [class.locked]="activity.IsLocked"
        (wheel)="onCellMouseWheel($event, activity, week.dates[0])">
      <div class="activity-cell no-select"
           [style]="buildActivityWeekStyle(activity, week)">&nbsp;</div>
    </td>
  </tr>
    </table>
  </div>
</div>
<span *ngIf="!isLoading && activityName" class="pager-block">
  <span style="margin-right: 15px;"> {{ getPagerStart() }} - {{ getPagerEnd() }} of {{ getProjectCount() }}</span>
  <label>Page:
    <select [(ngModel)]="page" (change)="loadProjectActivities()">
      <option *ngFor="let p of getPageNumbers()" [value]="p">{{ p }}</option>
    </select>
  </label>
</span>

<span
  *ngIf="weeklyProjectDetailsVisible"
  class="context-menu weekly-project-details"
  [style.top.px]="weeklyProjectDetailsPosition.y"
  [style.left.px]="weeklyProjectDetailsPosition.x">
  <project-card *ngIf="weeklyProjectDetailsData" [projectData]="weeklyProjectDetailsData"></project-card>
  <span *ngIf="!weeklyProjectDetailsData">Loading...</span>
</span>

<div *ngIf="contextMenuVisible" class="context-menu" [style.top.px]="contextMenuPosition.y" [style.left.px]="contextMenuPosition.x" (mouseleave)="closeContextMenu()">
  <div class="context-menu-item-disabled" *ngIf="!canEdit"><span class="material-icons context-menu-icon">lock</span>(Cannot Edit - User Account is Read-Only)</div>
  <div class="context-menu-item-disabled" *ngIf="canEdit && contextActivity.IsLocked"><span class="material-icons context-menu-icon">lock</span>(Activity Locked - From AX)</div>
  <div class="context-menu-item" *ngIf="canEdit && !contextActivity.IsMilestone && !contextActivity.IsConfirmed && !contextActivity.IsCompleted && !contextActivity.IsLocked" (click)="confirmRange()"><span class="material-icons context-menu-icon">check_circle</span>Confirm</div>
  <div class="context-menu-item" *ngIf="canEdit && contextActivity.IsMilestone && !contextActivity.IsConfirmed && !contextActivity.IsCompleted && !contextActivity.IsLocked" (click)="confirmAllRanges()"><span class="material-icons context-menu-icon">done_all</span>Confirm All</div>
  <div class="context-menu-item" *ngIf="canEdit && !contextActivity.IsLocked" (click)="openDuplicateDatesDialog()"><span class="material-icons context-menu-icon">content_copy</span>Duplicate Dates</div>
  <div class="context-menu-item" (click)="openNotes(contextActivity)"><span class="material-icons context-menu-icon">chat</span>Notes</div>
  <div class="context-menu-item" (click)="showSelectedHistory()"><span class="material-icons context-menu-icon">history</span>History</div>
  <div class="context-menu-item" *ngIf="canEdit && !contextActivity.IsMilestone && !contextActivity.IsLocked" (click)="deleteRange()"><span class="material-icons context-menu-icon">delete</span>Delete</div>
  <div class="context-menu-item" *ngIf="canEdit && !contextActivity.IsMilestone && contextActivity.IsConfirmed && !contextActivity.IsCompleted && !contextActivity.IsLocked" (click)="unconfirmRange()"><span class="material-icons context-menu-icon">undo</span>Unconfirm</div>
  <div class="context-menu-item" *ngIf="canEdit && !contextActivity.IsMilestone && contextActivity.IsConfirmed && !contextActivity.IsCompleted && !contextActivity.IsLocked" (click)="resetExpectedRange()"><span class="material-icons context-menu-icon">restore</span>Reset Expected</div>
  <div class="context-menu-item" *ngIf="canEdit && !contextActivity.IsMilestone && contextActivity.IsConfirmed && !contextActivity.IsCompleted && !contextActivity.IsLocked" (click)="completeRange()"><span class="material-icons context-menu-icon">task_alt</span>Complete</div>
  <div class="context-menu-item" *ngIf="canEdit && !contextActivity.IsMilestone && contextActivity.IsCompleted && !contextActivity.IsLocked" (click)="uncompleteRange()"><span class="material-icons context-menu-icon">remove_circle_outline</span>Uncomplete</div>
  <div class="context-menu-item" *ngIf="canOverrideExpectedDate(contextActivity)" (click)="openOverrideExpectedDateDialog()"><span class="material-icons context-menu-icon">event</span>Override Expected Date</div>
</div>

<div *ngIf="overrideExpectedDateVisible" class="modal-background">
  <div class="modal-dialog override-expected-date-dialog">
    <h2>Override Expected Dates</h2>
    <div class="override-expected-date-form-row">
      <label>
        Expected Start Date<br>
        <input type="date" [(ngModel)]="overrideExpectedStartDate" />
      </label>
    </div>
    <div class="override-expected-date-form-row">
      <label>
        Expected End Date<br>
        <input type="date" [(ngModel)]="overrideExpectedEndDate" />
      </label>
    </div>
    <div class="override-expected-date-form-row">
      <label>
        Comment / Justification<br>
        <textarea
          rows="5"
          class="override-expected-date-comment"
          [(ngModel)]="overrideExpectedDateComment"></textarea>
      </label>
    </div>
    <div class="override-expected-date-actions">
      <button class="geaui-button-secondary" (click)="closeOverrideExpectedDateDialog()">Cancel</button>
      <button class="geaui-button-primary" [disabled]="!canSubmitOverrideExpectedDate()" (click)="submitOverrideExpectedDate()">Submit</button>
    </div>
  </div>
</div>

<div *ngIf="duplicateDatesVisible" class="modal-background">
  <div class="modal-dialog" style="width: 700px; max-height: 700px; overflow-y: auto;">
    <h2>Duplicate Dates</h2>
    <div style="margin-bottom: 10px;">
      Select destination project(s):
    </div>
    <project-multi-selector
      [SelectedProjectId]="projectData?.Id"
      (SelectedProjectIds)="duplicateDatesSelectedProjectIds = $event">
    </project-multi-selector>
    <div style="margin-top: 20px; text-align: right;">
      <button class="geaui-button-secondary" (click)="closeDuplicateDatesDialog()">Cancel</button>
      <button class="geaui-button-primary" style="margin-left: 10px;" [disabled]="duplicateDatesSelectedProjectIds.length === 0" (click)="duplicateDates()">OK</button>
    </div>
  </div>
</div>

<div *ngIf="dateShifterVisible" class="date-shifter-menu" [style.top.px]="dateShifterPosition.y" [style.left.px]="dateShifterPosition.x">
  <div>
    <h3>Date Shifter</h3>
    <label> Shift Unconfirmed Dates By:
      <input type="number" [(ngModel)]="dateShiftDays" style="width: 60px;" /> work days
    </label>
    <!-- checkboxes to select each non milestone activity type -->
    <div *ngFor="let activity of activities" style="margin-top: 2px;">
      <label *ngIf="!activity.IsMilestone && !activity.IsConfirmed && activity.ExpectedStartDate && activity.ExpectedEndDate">
        <input type="checkbox" [checked]="dateShifterActivities.includes(activity)" (change)="toggleDateShifterActivitySelection(activity)" />
        <span class="material-icons filter-icon" [style.color]="getResponsiblePartyColor(activity.ResponsiblePartyId, false)">{{ getActivityIcon(activity) }}</span>
        {{ activity.Name }}
      </label>
    </div>
  </div>
  <div style="margin-top: 10px;">
    <button class="icon-button" (click)="applyDateShift()"><span class="material-icons filter-icon" [style.color]="'green'">check_circle</span> Apply</button>
    <button class="icon-button" (click)="closeDateShifter()"><span class="material-icons filter-icon" [style.color]="'red'">close</span> Cancel</button>
  </div>

</div>

<div *ngIf="activityHistoryVisible" class="modal-background">
  <div class="modal-dialog-wide">
    <h2>Activity History</h2>
    <div *ngIf="activityHistoryData.length === 0">
      No history data available.
    </div>
    <div style="max-height: 400px; overflow-y: auto;">
      <table>
        <tr style="font-weight: bold;">
          <td>Date</td>
          <td>User</td>
          <td>Source</td>
          <td>Expected Start</td>
          <td>Expected End</td>
          <td>Confirmed</td>
          <td>Actual Start</td>
          <td>Actual End</td>
          <td>Comment</td>
        </tr>
        <tr *ngFor="let record of activityHistoryData">
          <td>{{ toBrowserDate(record.Timestamp) | date:'short' }}</td>
          <td>{{ record.UserName }}</td>
          <td>{{ getSourceName(record.SourceId) }}</td>
          <td>{{ record.ExpectedStartDate | date:'shortDate' }}</td>
          <td>{{ record.ExpectedEndDate | date:'shortDate' }}</td>
          <td>{{ record.IsConfirmed ? 'Yes' : 'No' }}</td>
          <td>{{ record.ActualStartDate | date:'shortDate' }}</td>
          <td>{{ record.ActualEndDate | date:'shortDate' }}</td>
          <td>{{ record.Comment }}</td>
        </tr>
      </table>
    </div>
    <div style="text-align: right; margin-top: 12px;">
      <button class="geaui-button-secondary" (click)="closeActivityHistory()">Close</button>
    </div>
  </div>
</div>

<div *ngIf="backendCheckVisible" class="modal-background">
  <div class="modal-dialog">
    <h2>Updating...</h2>
    It has been a while since we last checked for updates from the server... <br>
    Hit F5 to refresh the data if this takes too long.
  </div>
</div>

<div *ngIf="filterMenuVisible" class="context-menu" 
     [style.top.px]="filterMenuPosition.y" 
     [style.left.px]="filterMenuPosition.x"
     (mouseleave)="filterMenuVisible = false">
  <div class="modal-dialog">
    <table>
      <tr>
        <td width="20%" style="vertical-align: top;">
          <h2>Activities</h2>
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showOnlyMilestones" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="'black'">circle</span> Show Only Milestones </label> <br />
          <hr />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showUnconfirmed" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="'#999999'">circle</span> Show Unconfirmed </label> <br />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showConfirmed" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="'#444444'">circle</span> Show Confirmed </label> <br />
          <hr />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showCustomer" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="getResponsiblePartyColor(0, false)">person</span> Show Customer </label> <br />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showSales" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="getResponsiblePartyColor(1, false)">sell</span> Show Sales </label> <br />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showEngineering" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="getResponsiblePartyColor(2, false)">settings</span> Show Engineering </label> <br />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showProduction" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="getResponsiblePartyColor(3, false)">build</span> Show Production </label> <br />
          <hr />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showEarly" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="'#77ff77'">circle</span> Show Early </label> <br />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showOnTime" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="'#999999'">circle</span> Show On Time </label> <br />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showInDanger" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="'#fff126ff'">circle</span> Show In Danger </label> <br />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showOnHold" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="'#7c3aed'">circle</span> Show On Hold </label> <br />
          <label> <input type="checkbox" [(ngModel)]="filterSettings.showLate" (change)="settingChanged()" /> <span class="material-icons filter-icon" [style.color]="'#FF0000'">circle</span> Show Late </label> <br />
        </td>
        <td width="20%" style="vertical-align: top;">
          <h2>Dates</h2>
          View:<br />
          <label>
            <input type="radio" name="viewMode" [(ngModel)]="filterSettings.showWeeks" [value]="false" (change)="viewModeChanged()" />
            Days
          </label>
          <label>
            <input type="radio" name="viewMode" [(ngModel)]="filterSettings.showWeeks" [value]="true" (change)="viewModeChanged()" />
            Weeks
          </label>
          <hr />
          <span *ngIf="!filterSettings.showWeeks">Show Days (auto): {{ filterSettings.daysShown }}</span>
          <span *ngIf="filterSettings.showWeeks">Show Weeks (auto): {{ filterSettings.daysShown }}</span>
          <hr *ngIf="!filterSettings.showWeeks" />
          <label *ngIf="!filterSettings.showWeeks"> <input type="checkbox" [(ngModel)]="filterSettings.showWeekends" (change)="dayRangeChanged()" /> Show Weekends </label>
          <br *ngIf="!filterSettings.showWeeks" />
          <label *ngIf="!filterSettings.showWeeks"> <input type="checkbox" [(ngModel)]="filterSettings.showFridays" (change)="dayRangeChanged()" /> Show Fridays </label>
          <br *ngIf="!filterSettings.showWeeks" />
          <hr />
          Starting Date: <br />
          <label> <input type="radio" name="startDateOption" [(ngModel)]="filterSettings.startAtToday" [value]="true" (change)="startAtChanged()" /> Today </label>
          <label> <input type="radio" name="startDateOption" [(ngModel)]="filterSettings.startAtToday" [value]="false" (change)="startAtChanged()" /> First Date </label>
        </td>
        <td width="20%" style="vertical-align: top;">
          <h2>Default Views</h2>
          <button class="icon-button" (click)="setAllView()"><span class="material-icons filter-icon" [style.color]="'#999999'">circle</span> All</button> <br />
          <button class="icon-button" (click)="setSalesView()"><span class="material-icons filter-icon" [style.color]="getResponsiblePartyColor(1, false)">sell</span> Sales</button> <br />
          <button class="icon-button" (click)="setEngineeringView()"><span class="material-icons filter-icon" [style.color]="getResponsiblePartyColor(2, false)">settings</span> Engineering</button> <br />
          <button class="icon-button" (click)="setProductionView()"><span class="material-icons filter-icon" [style.color]="getResponsiblePartyColor(3, false)">build</span> Production</button>

        </td>

      </tr>
    </table>
</div>
</div>

<div class="modal-background" *ngIf="showNotes">
  <div class="modal-dialog" style="width: 900px; height: 650px;">
    <h3 class="modal-heading">Notes for {{ notesActivity?.Name }}</h3>
    <br>

    <hrt-comment [comments]="notes" [commentType]="noteType" [canAddComment]="canEdit" (commentAdded)="addNote($event)"></hrt-comment>
    <br>

    <div style="text-align: right;">
      <button class="geaui-button-secondary" (click)="showNotes = false">Close</button>
    </div>
  </div>
</div>

<div *ngIf="singleProjectModalVisible" class="single-project-modal-background">
  <div class="single-project-modal" role="dialog" aria-modal="true" aria-label="Project master schedule">
    <button class="single-project-modal-close" type="button" (click)="closeProjectModal()" aria-label="Close project calendar" title="Close">
      <span class="material-icons">close</span>
    </button>
    <master-schedule-single-project
      class="modal-project-calendar"
      [project]="singleProjectModalProject"
      [projectNumberClickEnabled]="false"
      (closeRequested)="closeProjectModal()">
    </master-schedule-single-project>
  </div>
</div>